import { gql } from "@apollo/client";

const GET_COMMISSION = gql`
  query GetCommissionData($input: SellerId!) {
    getCommission(input: $input) {
      data {
        _id
        commission
        sellerId
        type
        ruleBy
        advance {
          vendorId
          categoryId
          type
          option
          commission
        }
        range {
          commission
          max
          min
          type
        }
        isOrderBased
        createdAt
        updatedAt
      }
      status
      error
    }
  }
`;

export default GET_COMMISSION;
